var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-scroll-area',{staticClass:"fit column",attrs:{"thumb-style":{
    right: '0',
    borderRadius: '5px',
    backgroundColor: '#CFD8DC',
    width: '5px',
    opacity: 0.75,
  }}},[_c('div',{staticClass:"col-auto shop-sidebar"},[_c('q-tabs',{staticClass:"text-primary fit",attrs:{"centered":"","vertical":"","stretch":"","switch-indicator":"","animated":""}},[_c('AppsTabsComponent')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }